/**
 * Audited Annual Accounts 2025–26 — exact rupee amounts.
 * Display formatting happens in lib/formatMoney.js.
 *
 * Set REACT_APP_ACCOUNTS_PDF_URL to the hosted PDF when it is available.
 */
export const annualAccounts2025_26 = {
  yearLabel: "2025–26",
  priorYearLabel: "2024–25",
  asAt: "31 March 2026",
  asAtPrior: "31 March 2025",
  organisation: "The Bombay Catholic Sabha",
  auditors: "Pereira & Subramanian, Chartered Accountants",
  pdfUrl:
    process.env.REACT_APP_ACCOUNTS_PDF_URL ||
    "https://pub-c0208a4578ba4aeb9e729da4dfc2d05c.r2.dev/pdfs/ANNUAL%20ACCOUNTS%202025%202026%20DD.pdf",
  motto: "Committed to a better tomorrow, today.",

  income: {
    total: 5720159,
    prior: 2720133,
    programmes: 4698760,
    programmesPrior: 2005159,
    interest: 829164,
    interestPrior: 566666,
    membership: 192235,
    membershipPrior: 148309,
  },

  expenditure: {
    total: 4357351,
    prior: 3957758,
    programmes: 2956851,
    programmesPrior: 2294671,
    administrative: 1069214,
    administrativePrior: 1192195,
    depreciation: 153986,
    depreciationPrior: 159492,
    professionalFees: 112400,
    professionalFeesPrior: 246500,
    auditFees: 64900,
    auditFeesPrior: 64900,
    otherCharitable: 0,
    covid: 0,
  },

  result: {
    surplus: 1362808,
    priorDeficit: -1237625,
  },

  balanceSheet: {
    total: 23810730,
    prior: 22316300,
    fixedAssetsNet: 6069663,
    fixedAssetsNetPrior: 6076416,
    investments: 10708754,
    investmentsPrior: 10574954,
    netCurrentAssets: 7032313,
    netCurrentAssetsPrior: 5664929,
    bankBalances: 5632000,
    bankBalancesPrior: 4372000,
    incomeExpenditureAccount: 7404529,
    incomeExpenditureAccountPrior: 6041721,
  },

  funds: {
    reserveAndOther: 13893314,
    reserveAndOtherPrior: 13761691,
    corpus: 2512887,
    corpusPrior: 2512887,
    items: [
      { name: "Office Premises Fund", amount: 6040000 },
      { name: "Civil Service Training Fund", amount: 2126000 },
      { name: "Legal & Advocacy Fund", amount: 1825000 },
      { name: "Education Scholarship Fund", amount: 1309000 },
      { name: "Fr. Salvador Scholarship Fund", amount: 478000 },
      { name: "Disaster Management Fund", amount: 391000 },
      { name: "Fr. Edward D'Souza Fund", amount: 381000 },
      { name: "Depreciation Fund", amount: 298000 },
      { name: "Parish Units Fund", amount: 288000 },
      { name: "Sports Talent Fund", amount: 42000 },
    ],
  },

  interestBreakdown: [
    { name: "Fixed Deposits with Banks", amount: 726000 },
    { name: "Savings Bank", amount: 103164 },
  ],

  programmeIncome: [
    { name: "Donations", amount: 2445884 },
    { name: "Advertisement in Sabha Day Souvenir", amount: 1298501 },
    { name: "Social, Cultural Programmes / Training / Other", amount: 684905 },
    { name: "Sabha Day Income", amount: 235950 },
    { name: "Sabha Day Advertisement Incentive", amount: 14150 },
    { name: "Independence Day Flag Contribution", amount: 9495 },
    { name: "Benefactor's Income", amount: 7500 },
    { name: "Miscellaneous Income", amount: 2375 },
  ],

  programmeExpenses: [
    { name: "Programmes & Functions", amount: 1455315 },
    { name: "Sabha Day Life Expenses", amount: 838350 },
    { name: "Meeting Expenses", amount: 269413 },
    { name: "Scholarship Awards", amount: 241200 },
    { name: "BCS Cricket", amount: 54000 },
    { name: "Youth Forum", amount: 38610 },
    { name: "Advertisement Expenses", amount: 28060 },
    { name: "BCS Footcom", amount: 25903 },
    { name: "Fr. Salvador Memorial", amount: 20000 },
    { name: "Fr. Edward D'Souza Memorial", amount: 20000 },
    { name: "AICU Expenses", amount: 20000 },
    { name: "Orientation Expenses", amount: 9000 },
    { name: "Donation", amount: 0 },
    { name: "Seminar Expenses", amount: 0 },
  ],
};

/** Calculated year-on-year improvement: surplus minus prior deficit. Not an audited line item. */
export function annualResultImprovement(data = annualAccounts2025_26) {
  return data.result.surplus - data.result.priorDeficit;
}
